/**
 * Mapeo de equipo de ventas (nombre canónico de SALES_TEAMS) → branch slug
 * de la Support API.
 */
export const TEAM_CASH_BRANCH: Record<string, string> = {
	'CENTRO UY': 'caja-centro',
	'WTC UY': 'caja-wtc',
	PY: 'caja-wtc-py',
	BO: 'caja-shopping-fidalga-bo',
	CO: 'caja-bog-co',
};

/** Branch slug de la caja central (HQ) — no asociada a ningún equipo de ventas. */
export const HQ_CASH_BRANCH = 'caja-hq';

/**
 * Monedas que puede manejar cada caja, en orden de presentación.
 * Esto define las opciones del selector de moneda en el modal de movimiento,
 * independientemente de si hay balance registrado o no.
 */
export const BRANCH_CURRENCIES: Record<string, string[]> = {
	'caja-centro': ['USD', 'UYU'],
	'caja-wtc': ['USD', 'UYU'],
	'caja-hq': ['USD', 'UYU'],
	'caja-wtc-py': ['USD', 'PYG'],
	'caja-shopping-fidalga-bo': ['USD', 'BOB'],
	'caja-bog-co': ['USD', 'COP'],
};

/**
 * Sucursales que operan con caja fuerte (pestaña "Caja fuerte" + reparto
 * banco/caja fuerte en el acta de depósito).
 *
 * Todas. Se deriva de las cajas existentes en vez de listar los slugs a mano
 * para que una sucursal nueva no nazca sin caja fuerte por olvido.
 *
 * El saldo de una caja fuerte sin movimientos es cero, así que habilitarla no
 * altera nada de lo ya cargado. Si alguna sucursal no debiera tenerla, la
 * forma de excluirla es filtrar acá.
 */
export const VAULT_BRANCHES: string[] = [...Object.values(TEAM_CASH_BRANCH), HQ_CASH_BRANCH];

/** Monto máximo (en moneda principal) antes de que la caja deba depositarse. */
export const CASH_DEPOSIT_LIMIT = 5000;

/** Umbral de aviso cuando la caja se está acercando al límite. */
export const CASH_DEPOSIT_WARNING = 4000;
